export default __webpack_public_path__ + "static/media/a1.84d8436e.jpg";